import { IConfigsType } from '../../types'

const fwWingstopPrepItemConfiguration: IConfigsType = {
  'fw_wingstop-expo-admin': {
    '/:brand/prep_item_configuration': {
      title: {
        type: 'title',
        title: 'Prep Item Configuration',
      },
      prepItemConfiguration: {
        type: 'ai-blackbox-wrapper',
        contentPartNames: ['fwWingstopPrepItemConfiguration'],
      },
    },
  },
}

export default fwWingstopPrepItemConfiguration
